
import createIcon from "./createIcon";

export const RefreshIcon = createIcon('Refresh', (props) => {
  return (
    <svg {...props}>
      <g>
        <path d="M7.99895,1C6.4862,1,5.09062,1.506342,3.96914,2.36001C3.71597,2.5525,3.69295,2.9249400000000003,3.91892,3.15091C4.10514,3.33713,4.40016,3.35805,4.60939,3.19694C5.55094,2.48137,6.72682,2.0545299999999997,7.99686,2.0545299999999997C10.9261,2.0545299999999997,13.3407,4.31215,13.5896,7.17654Q13.6127,7.45064,13.5855,7.66824L12.2673,7.6787L13.8679,10.8674Q14.006,10.8674,16,7.66614L14.6651,7.66614C14.6714,7.31882,14.6484,7.1598,14.6421,7.09285C14.3492,3.68445,11.4806,1.00209307,7.99895,1ZM7.99895,13.2819C4.90231,13.2819,2.38525,10.76278,2.38525,7.66824L2.38525,7.66196L3.71806,7.64731L2.13417,4.4669799999999995L0,7.66614L1.33281,7.66614C1.33072,11.4072,4.51314,14.3365,7.99895,14.3365C9.5682,14.3365,11.014,13.7904,12.1543,12.8802C12.3991,12.6835,12.4179,12.3174,12.1962,12.0956C12.0058,11.9052,11.7045,11.8885,11.4952,12.0558C10.5349,12.8237,9.31921,13.2819,7.99895,13.2819Z" fill={props.color} fillOpacity="1" />
      </g>
    </svg >
  )
});
